// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1v17I","colBig":"styles_colBig__3dhbI","colSmall":"styles_colSmall__37BBE"};